import { format } from "date-fns";
import { dateFormatISO } from "~/src/components/CalendarPicker/CalendarConstants";
import { ArtType } from "../../../helpers/types";
import IndividForm from "../components/IndividForm";
import { IndividData } from "../schemas/schema";

const DEFAULT_VILLREIN: IndividData = {
  Id: "",
  Dato: "",
  Art: ArtType.Villrein,
  Villreinvald: "",
};

export default function RegistrerVillrein(): JSX.Element {
  return (
    <div className="h-full flex">
      <IndividForm
        className="pt-4"
        initialInfo={{ ...DEFAULT_VILLREIN, Dato: format(new Date(), dateFormatISO) }}
        mode="create"
      />
    </div>
  );
}
